export default "__VITE_ASSET__Dbw3wUXF__"